<template>
  <div class="monit-page">
    <div class="monit-main row justify-content-sb">
      <h3 v-if="mobile" class="page-title col-xs-12 col-sm-6 pt-2">
        Monitore dispositivos
      </h3>
      <toolbar
        v-if="mobile"
        class="col-xs-12 col-sm-6"
        type="dirs"
        :is-mobile="mobile"
        :filter-opt="filterOpt"
        :is-filtering="isFiltering"
        @filter-by="onFilterBy"
        :type-filtering="
          tab1.toLowerCase() === 'exibir todos' ? '' : tab1.toLowerCase()
        "
        @search="searchBy"
        @clear-search="onClearSearch"
        @reset="resetProp"
        :is-searching="isSearching"
        :filters="filters"
        :types-options="options"
        :filter-tag="filterBy === 100 ? true : false"
        @type-change="changeTypeMobile"
        :not-exists="showErrorNotFound"
        :not-search="showErrorNotSearch"
        ref="INP"
      />

      <!-- Filtros mobile -->
      <div v-if="mobile" class="mobile-filter-bar col-xs-12">
        <b-btn size="sm" variant="outline-secondary" class="mobile-filter-toggle" @click="showMobileFilters = !showMobileFilters">
          <filter-outline-icon title="" /> Filtros
          <span v-if="mobileFilterModel.length || mobileFilterStatus !== null" class="filter-active-dot"></span>
        </b-btn>
        <b-collapse v-model="showMobileFilters">
          <div class="mobile-filter-panel">
            <div v-if="options && options.length">
              <div class="filter-section-label">Modelo</div>
              <b-form-checkbox-group v-model="mobileFilterModel" name="mobile-model-filters"
                button-variant="info" size="sm" stacked>
                <b-form-checkbox v-for="opt in options" :key="opt.value" :value="opt.value">
                  {{ opt.text }} <span class="model-count">({{ opt.count }})</span>
                </b-form-checkbox>
              </b-form-checkbox-group>
            </div>
            <div class="filter-section-label mt-2">Comunicação</div>
            <b-form-radio-group v-model="mobileFilterStatus" buttons button-variant="light" size="sm">
              <b-form-radio :value="null">Todos</b-form-radio>
              <b-form-radio :value="0">Comunicando</b-form-radio>
              <b-form-radio :value="7">Timeout</b-form-radio>
              <b-form-radio :value="8">Falha 1</b-form-radio>
              <b-form-radio :value="9">Falha 2</b-form-radio>
              <b-form-radio :value="'nosync'">Não sincronizados</b-form-radio>
              <b-form-radio :value="'neversync'">Nunca comunicaram</b-form-radio>
            </b-form-radio-group>
          </div>
        </b-collapse>
      </div>

      <div v-if="loading" class="col-xs-12 center-xs mt-2">
        <spinner /> Aguarde...
      </div>
      <div
        v-if="showErrorNotSearch && !showErrorNotFound"
        class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
        style="text-align: left"
      >
        <img :src="searchIcon" class="empty" />
        <span>
          Não foi possível realizar a busca,
          <b-link @click="resetSearch"> clique aqui </b-link> para voltar a
          exibir os dispositivos.</span
        >
      </div>

      <div
        v-if="showErrorNotFound"
        class="EmptyRequest w-100 p-0 row center-xs center-md center-sm center-xs mt-3"
      >
        <img :src="emptyIcon" class="empty" />
        <span
          >Não há dispositivos para exibir. Para cadastrar um novo,
          <router-link to="/registers/devices">clique aqui</router-link></span
        >
      </div>

      <!-- CARDS -->
      <div class="container-cards">
        <div
          v-for="(item, index) in orderedList"
          :key="index"
          class="dir-space-card"
        >
          <router-link
            :to="`/monitoring/dirs/`"
            @click.native="
              () => {
                openDetailsDialog(item);
                selectedCard = index;
              }
            "
          >
            <div
              :class="`monitCard ${setBGBody(item.RF.stat)} ${
                selectedCard == index ? 'activeCard' : ''
              } ${alertClass(item)}`"
            >
              <div :class="`top ${setBG(item.RF.stat)}`"></div>
              <div class="monit-name">
                {{ dirLabel(item) }}
                <div v-if="dirModelLabel(item)" class="monit-model">{{ dirModelLabel(item) }}</div>
              </div>

              <div class="info">
                <div class="percent-card">
                  <wifi-icon title="Sinal" />
                  <span>Sinal:</span>
                  <span>
                    {{
                      item.RF && item.RF.ack && item.RF.ack.length == 2
                        ? calculatePercentage(item.RF.ack[0], item.RF.ack[1]) +
                          "%"
                        : "Sem sinal"
                    }}
                  </span>
                </div>
                <div v-if="item.BAT" class="BAT" :class="{ 'bat-low': isLowBattery(item) }">
                  <battery-outline-icon title="Bateria" />
                  <span>Bateria: </span>
                  <span>{{ item.BAT }} V</span>
                </div>
              </div>
              <div v-if="isNotSynced(item)" class="warn-card warn-card--sync">
                <alert-icon title="" style="font-size: 0.9em" /><span>Não sincronizado</span>
              </div>
              <div v-if="isLowBattery(item)" class="warn-card warn-card--battery">
                <alert-icon title="" style="font-size: 0.9em" /><span>Bateria baixa</span>
              </div>

              <footer>
                <!-- item.UPDATE é quando o firmware regravou o snapshot JSON, não quando o
                     DIR respondeu de fato -- lastComm() (GENERIC "Última comunicação:") é o
                     dado real. Fallback pra item.UPDATE só quando o GENERIC nem existe
                     (firmware antigo), não quando lastComm() é "Nunca" (aí vira o alerta). -->
                <div v-if="lastComm(item) === 'Nunca'" id="date" class="date-never-synced">
                  Aguardando comunicação
                </div>
                <div v-else id="date">{{ formatUpdate(lastComm(item) || item.UPDATE) }}</div>
                <div :class="`status ${setBG(item.RF.stat)}`">
                  {{ selectInfoStatus(item.RF.stat) }}
                </div>
              </footer>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <!-- BARRA DA DIREITA -->
    <div class="monit-helper" v-if="!mobile">
      <div class="container-helper">
        <header>
          <div class="header-group">
            <dir-icon title="" customHeight="20px" />
            <div class="title-monit-helper">Monitore dispositivos</div>
          </div>
          <toolbar
            v-if="!mobile"
            class="toolbar"
            type="dirs"
            :is-mobile="mobile"
            :filter-opt="filterOpt"
            :is-filtering="isFiltering"
            @filter-by="onFilterBy"
            @search="searchBy"
            @clear-search="onClearSearch"
            :is-searching="isSearching"
            :type-filtering="
              tab1.toLowerCase() === 'exibir todos' ? '' : tab1.toLowerCase()
            "
            :not-exists="showErrorNotFound"
            :not-search="showErrorNotSearch"
          />
        </header>
        <!-- <br /> -->
        <div class="filter-container mt-2">
          <div class="col-xs-12 filter-title">
            <h5>Dispositivos</h5>
            <span>{{ orderedList.length }}</span>
          </div>

          <div v-if="options && options.length" class="filter-section p-2">
            <div class="filter-section-label">Filtrar por modelo</div>
            <b-form-checkbox-group id="checkbox-group-1" v-model="selectedCheckbox"
              name="filters" button-variant="info" size="sm" stacked>
              <b-form-checkbox v-for="opt in options" :key="opt.value" :value="opt.value">
                {{ opt.text }} <span class="model-count">({{ opt.count }})</span>
              </b-form-checkbox>
            </b-form-checkbox-group>
          </div>

          <div class="filter-section p-2">
            <div class="filter-section-label">Filtrar por comunicação</div>
            <b-form-radio-group v-model="selectedRadiusButton" buttons button-variant="light" size="sm" stacked>
              <b-form-radio :value="null">Exibir todos</b-form-radio>
              <b-form-radio :value="0">Comunicando ({{ alerts[0].length }})</b-form-radio>
              <b-form-radio :value="7">Perdendo sinal ({{ alerts[7].length }})</b-form-radio>
              <b-form-radio :value="8">Falha 1 ({{ alerts[8].length }})</b-form-radio>
              <b-form-radio :value="9">Falha 2 ({{ alerts[9].length }})</b-form-radio>
              <b-form-radio :value="'nosync'">Não sincronizados ({{ alerts["nosync"].length }})</b-form-radio>
              <b-form-radio :value="'neversync'">Nunca comunicaram ({{ alerts["neversync"].length }})</b-form-radio>
            </b-form-radio-group>
          </div>
        </div>
      </div>
    </div>

    <dirs-details
      :item="selected"
      :my-time="
        Object.keys(selected).length && selected.RF
          ? { n1: selected.RF.ack[0], n2: selected.RF.ack[1] }
          : {}
      "
      :status-color="variant"
      :updated="updated"
      :variant="variant"
      :show-details="showDetails"
      :is-mobile="mobile"
      :success-percentage="
        Object.keys(selected).length &&
        selected.RF &&
        calculatePercentage(selected.RF.ack[0], selected.RF.ack[1])
      "
      @close-details="closeDetails"
    />
  </div>
</template>

<script>
import { monitSignal, updateFormatter } from "@/pages/components/helpers";
import EventBus from "@/pages/components/eventBus";
import { monit } from "@/api";
// Mesmo limite usado no gráfico de bateria do DIR (charts.js LOW_BATTERY) —
// abaixo disso o card destaca a bateria como baixa.
const LOW_BATTERY = 11.8;
export default {
  name: "monit-dirs",
  props: {
    mobile: Boolean,
  },
  created() {
    this.$emit(
      "title-change",
      this.mobile ? "M. de DIRs" : "Monitoramento de DIRs"
    );
    // Com o AbortController eu consigo abortar as requisições quando e onde quiser
    this.controller = new AbortController();

    this.monitLoop();
    this.selectedRadiusButton = null;
    if (!this.type) {
      this.tab1 = "EXIBIR TODOS";
    }
    console.log(this.searchBy);
  },
  data() {
    return {
      showDetails: false,
      showMobileFilters: false,
      mobileFilterModel: [],
      mobileFilterStatus: null,
      tab1: "",
      tab2: "",
      type: null,
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      list: [],
      fullList: [],
      backendNow: null,
      loading: true,
      selected: {},
      selectedCard: null,
      filterBy: 100,
      missingResults: false,
      isSearching: false,
      isFiltering: false,
      filter: "",
      filterOpt: "",
      checkboxList: [],
      selectedCheckbox: [],
      selectedRadiusButton: "",
      options: [],
      filters: [
        { text: "Comunicando", value: 0 },
        { text: "Timeout", value: 7 },
        { text: "Falha 1", value: 8 },
        { text: "Falha 2", value: 9 },
        { text: "Não sincronizados", value: "nosync" },
        { text: "Nunca comunicaram", value: "neversync" },
      ],
      items: [],
      controller: null,
      timeout: null,
      regexMTD: new RegExp("MTD"),
      alerts: {
        0: [],
        7: [],
        8: [],
        9: [],
        nosync: [],
        neversync: [],
      },
      showErrorNotFound: false,
      showErrorNotSearch: false,
      myTime: "",
    };
  },
  beforeDestroy() {
    this.controller.abort();
    clearTimeout(this.timeout);
  },
  watch: {
    selectedCheckbox() {
      if (!this.mobile) {
        this.isActive(this.items);
      }
    },
    selectedRadiusButton(v) {
      if (v != null) {
        this.onFilterBy(v);
      } else {
        this.showErrorNotSearch = false;
        this.onFilterBy(100);
      }
    },
    mobile(newValue, oldValue) {
      if (newValue) {
        this.showErrorNotSearch = false;
        this.showErrorNotFound = false;
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.isSearching = false;
        this.filter = "";
      } else {
        this.resetSearch();
      }
    },
  },
  methods: {
    selectCard(item, index) {
      this.selectedCard = index;
      openDetailsDialog(item);
    },
    closeDetails() {
      this.showDetails = false;
      this.selectedCard = null;
      this.selected = {};
    },
    resetSearch() {
      this.selectedCheckbox = [];
      this.selectedRadiusButton = null;
      EventBus.cleanInputSearch();
      this.filter = "";
      // this.resetDropdown();
      this.isSearching = false;
      this.items = this.fullList;
      this.showErrorNotSearch = false;
      this.resetProp();
      this.resetDropdown();
      this.clearSearchInput();
    },
    onClearSearch() {
      this.filter = "";
      this.resetDropdown();
    },
    selectDropdownItem(option) {
      this.type = option;
      this.clearSearchInput();
    },
    changeTypeMobile(t) {
      this.type = t;
    },
    resetProp() {
      this.onFilterBy(100);
    },
    // Nome de exibição em destaque no card: nome cadastrado pra MTD, endereço
    // (ou "CIR") pros demais — modelo vai à parte em dirModelLabel.
    dirLabel(item) {
      return this.regexMTD.test(item.MODEL)
        ? item.NAME
        : item.MODEL === "CIR"
        ? "CIR"
        : item.ID;
    },
    dirModelLabel(item) {
      return item.MODEL && item.MODEL !== "CIR" ? item.MODEL : null;
    },
    isLowBattery(item) {
      return !!item.BAT && Number(item.BAT) < LOW_BATTERY;
    },
    // Campo novo do firmware — dispositivos com firmware antigo simplesmente não
    // mandam SYNC no JSON (undefined), então o card não mostra alerta nenhum em
    // vez de quebrar ou dar falso positivo.
    isNotSynced(item) {
      if (!(item.SYNC === false || item.SYNC === 0)) return false;
      // Dispositivo que nunca comunicou (GENERIC "Última comunicação:" ==
      // "Nunca") não tem config nenhuma pra estar sincronizado ou não --
      // "Não sincronizado" aqui só seria ruído redundante com o próprio
      // status TIMEOUT/sem sinal já exibido no card.
      return this.lastComm(item) !== "Nunca";
    },
    lastComm(item) {
      const found =
        item.GENERIC && item.GENERIC.find((g) => g.NAME === "Última comunicação:");
      return found ? found.VALUE : null;
    },
    // "Não sincronizado" é mais grave que bateria baixa — decide a cor da borda
    // do card quando os dois puderem ocorrer juntos.
    alertClass(item) {
      if (this.isNotSynced(item)) return "has-alert has-alert--error";
      if (this.isLowBattery(item)) return "has-alert has-alert--warning";
      return "";
    },
    isActive(result) {
      let dirs = [];
      const regexMTD = new RegExp("MTD");
      if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        this.selectedCheckbox.length > 0
      ) {
        this.isFiltering = false;
        dirs = this.isSearchDropdown(result);
        if (result.length) {
        }
      } else if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        !this.selectedCheckbox.length
      ) {
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        dirs = this.fullList;
      } else if (!this.mobile) {
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        dirs = this.fullList;
      } else if (this.mobile && this.type && !regexMTD.test(this.type)) {
        this.tab1 = this.type;
        this.title = "DIR";
        // this.clearSearch();
        if (result.length) {
          dirs = this.isSearchDropdown(result);
        }
      }
      // Quando for MTD
      else if (this.mobile && this.type && regexMTD.test(this.type)) {
        this.tab1 = this.type;
        this.title = "MTD";
        if (result.length) {
          dirs = this.isSearchDropdown(result);
        }
      } else if (this.mobile && !this.type) {
        this.showErrorNotSearch = false;
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        dirs = this.fullList;
      }
      return dirs;
    },
    isSearch(result) {
      let filter;
      filter = result.filter((item) => {
        if (item.MODEL !== "MTD" && item.ID.indexOf(this.filter) > -1) {
          return true;
        }
        if (item.MODEL === "MTD" && item.NAME.indexOf(this.filter) > -1) {
          return true;
        }
        if (item.MODEL && item.MODEL.indexOf(this.filter) > -1) {
          return true;
        }
        if (item.MODEL_NAME && item.MODEL_NAME.indexOf(this.filter) > -1) {
          return true;
        }
      });
      if (filter.length) {
        this.showErrorNotSearch = false;
        return filter;
      } else {
        this.showErrorNotSearch = true;
        return [];
      }
    },
    isSearchDropdown(result) {
      if (this.mobile) {
        let filter;
        filter = result.filter((item) => item.MODEL == this.type);
        if (filter.length) {
          this.showErrorNotSearch = false;
          return filter.sort((a, b) => a.ID - b.ID);
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      } else {
        let results = [];
        for (let checkbox of this.selectedCheckbox) {
          let filter = result.filter((item) => item.MODEL == checkbox);
          results.push(...filter);
        }
        if (results.length) {
          this.showErrorNotSearch = false;
          return results.sort((a, b) => a.ID - b.ID);
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      }
    },
    monitLoop() {
      monit
        .dir(this.controller)
        .then((res) => {
          this.backendNow = Date.parse(res.headers.get("date"));
          return res.json();
        })
        .then((ret) => {
          let list = ret;
          this.loadFilterModels(ret);
          this.fullList = list;
          // Se tiver pesquisando, se o filtro for válido e tiver items
          if (this.isSearching && this.validFilter && list.length) {
            this.items = this.isSearch(list);
          } else this.items = list;
          if (this.loading) this.loading = false;
          if (
            Object.keys(this.selected).length &&
            this.selected.ID &&
            list.length
          ) {
            this.selected =
              list.filter((e) => e.ID == this.selected.ID)[0] || this.selected;
          }
          return;
        })
        .catch((err) => {
          return err.name;
        })
        .then((_) => {
          if (!this.loading && !this.items.length && !this.showErrorNotSearch) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        })
        .then((ret) => {
          if (ret !== "AbortError") {
            this.timeout = setTimeout(this.monitLoop, 2000);
          }
        });
    },
    formatUpdate(update) {
      this.myTime = updateFormatter(update);
      return updateFormatter(update);
    },
    setBG(stat) {
      switch (stat) {
        case 0:
          return "bg-3v3";
        case 7:
          return "bg-yellow";
        case 8:
          return "bg-red";
        case 9:
          return "bg-black";
        default:
          return "bg-grey";
      }
    },
    selectInfoStatus(stat) {
      switch (stat) {
        case 0:
          return "COMUNICANDO";
        case 7:
          return "TIMEOUT";
        case 8:
          return "FALHA";
        case 9:
          return "FALHA";
        default:
          return "VERIFICANDO";
      }
    },
    setBGBody(stat) {
      switch (stat) {
        case 0:
          return "";
        case 7:
          return "";
        case 8:
          return "bg-red-body";
        case 9:
          return "bg-black-body";
        default:
          return "";
      }
    },
    resetDropdown() {
      this.type = null;
      this.tab1 = "EXIBIR TODOS";
      this.isSearching = false;
      this.showErrorNotSearch = false;
      this.items = this.fullList;
    },
    searchBy(addr) {
      console.log(addr);
      this.isSearching = !!addr.split(" ").join("");
      // if (!this.selectedRadiusButton) {
      // }
      this.filter = addr;
    },
    clearSearch() {
      if (!!this.$children[0] && this.$children[0].length > 0) {
        this.$children[0].clearText();
      }
      this.isSearching = false;
      this.missingResults = false;
    },
    clearSearchInput() {
      if (!!this.$children[0] && this.$children[0].length > 0) {
        this.$children[0].clearText();
      }
      this.isSearching = false;
      this.items = this.fullList;
    },
    onFilterBy(value) {
      // if (value == 100) this.clearSearch();
      this.isFiltering = value != 100;
      if (value.text) {
        this.filterOpt = value.text;
      }
      this.filterBy = value;
    },
    openDetailsDialog(item) {
      this.selected = item;
      this.showDetails = true;
    },
    calculatePercentage(value, ref) {
      if (!ref) return 0;
      let percent = (value * 100) / ref;
      if (percent > 100) return 100;
      else if (percent < 0) return 0;
      else return parseInt(percent);
    },
    selectInfo(item) {
      let info = [];
      if (signal) {
        info.push(item.BAT + "V");
      }
      return info;
    },
    // ! Carregar opções dropdown
    loadFilterModels(ret) {
      this.loading = true;
      // this.clearSearch();

      // Conta quantos dispositivos existem em cada modelo, pra mostrar ao
      // lado do nome no filtro (ex. "DIR_PS (12)") -- só informativo, não
      // muda o comportamento do filtro em si.
      const counts = {};
      ret.forEach((obj) => {
        counts[obj.MODEL] = (counts[obj.MODEL] || 0) + 1;
      });

      let options = [];
      Object.keys(counts).forEach((el) => {
        options.push({ text: el, value: el, count: counts[el] });
      });
      this.options = options;
      this.loading = false;
    },
  },
  computed: {
    updated() {
      return Object.keys(this.selected).length && this.selected.UPDATE
        ? this.formatUpdate(this.selected.UPDATE)
        : "";
    },
    variant() {
      return Object.keys(this.selected).length
        ? this.setBG(this.selected.RF && this.selected.RF.stat).split("-")[1]
        : "bg-grey";
    },
    validFilter() {
      return !!this.filter.split(" ").join("");
    },
    orderedList() {
      let filter = this.filterBy;
      let result = this.items;
      if (result.length > 0) {
        result = this.isActive(result);
      }
      this.alerts[0] = result.filter((item) => item.RF.stat == 0);
      this.alerts[7] = result.filter((item) => item.RF.stat == 7);
      this.alerts[8] = result.filter((item) => item.RF.stat == 8);
      this.alerts[9] = result.filter((item) => item.RF.stat == 9);
      this.alerts["nosync"] = result.filter((item) => this.isNotSynced(item));
      this.alerts["neversync"] = result.filter((item) => this.lastComm(item) === "Nunca");
      if (
        this.isSearching &&
        this.validFilter &&
        result.length &&
        this.selectedRadiusButton == null
      ) {
        result = this.isSearch(result);
        this.alerts[0] = result.filter((item) => item.RF.stat == 0);
        this.alerts[7] = result.filter((item) => item.RF.stat == 7);
        this.alerts[8] = result.filter((item) => item.RF.stat == 8);
        this.alerts[9] = result.filter((item) => item.RF.stat == 9);
        this.alerts["nosync"] = result.filter((item) => this.isNotSynced(item));
        this.alerts["neversync"] = result.filter((item) => this.lastComm(item) === "Nunca");
      }
      if (
        this.isSearching &&
        this.validFilter &&
        this.selectedRadiusButton !== null
      ) {
        result = this.isSearch(result);
        this.alerts[0] = result.filter((item) => item.RF.stat == 0);
        this.alerts[7] = result.filter((item) => item.RF.stat == 7);
        this.alerts[8] = result.filter((item) => item.RF.stat == 8);
        this.alerts[9] = result.filter((item) => item.RF.stat == 9);
        this.alerts["nosync"] = result.filter((item) => this.isNotSynced(item));
        this.alerts["neversync"] = result.filter((item) => this.lastComm(item) === "Nunca");
        if (filter != 100) {
          if (this.mobile) {
            result = this.alerts[filter.value];
            try {
              if (!result.length) {
                this.showErrorNotSearch = true;
              } else {
                this.showErrorNotSearch = false;
              }
            } catch (error) {
              console.log("Result -> error :", error);
            }
          } else {
            result = this.isSearch(this.alerts[filter]);
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          }
        }
      }
      // Estiver filtrando por comunicação
      else if (filter != 100) {
        if (this.mobile) {
          result = this.alerts[filter.value];
          try {
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          } catch (error) {
            console.log("Result -> error :", error);
          }
        } else {
          result = this.isSearch(this.alerts[filter]);
          if (!result.length) {
            this.showErrorNotSearch = true;
          } else {
            this.showErrorNotSearch = false;
          }
        }
      }
      if (this.mobile) {
        if (this.mobileFilterModel.length > 0) {
          result = result.filter(item => this.mobileFilterModel.includes(item.MODEL));
        }
        if (this.mobileFilterStatus === "nosync") {
          result = result.filter(item => this.isNotSynced(item));
        } else if (this.mobileFilterStatus === "neversync") {
          result = result.filter(item => this.lastComm(item) === "Nunca");
        } else if (this.mobileFilterStatus !== null) {
          result = result.filter(item => item.RF.stat == this.mobileFilterStatus);
        }
      }

      return result;
    },
  },
};
</script>

<style scoped>
.monit-main {
  align-content: flex-start;
}
.model-count {
  color: var(--text-gray-primary, #5f5f5f);
  font-size: 0.85em;
}
.filter-section {
  border-bottom: 1px solid var(--border-grey-color-secondary);
}
.filter-section:last-child {
  border-bottom: none;
}
.filter-section-label {
  font-family: "SourceSansPro_Semibold", Arial, Helvetica, sans-serif;
  font-size: 0.8em;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.04em;
  margin-bottom: 6px;
}
.mobile-filter-bar {
  padding: 4px 8px 0;
}
.mobile-filter-toggle {
  font-size: 0.85em;
}
.filter-active-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  background: var(--orange-color);
  border-radius: 50%;
  margin-left: 4px;
  vertical-align: middle;
}
.mobile-filter-panel {
  background: #f9f9f9;
  border: 1px solid var(--border-grey-color-secondary);
  border-radius: 4px;
  padding: 10px 12px;
  margin-top: 6px;
}
.monitCard .info {
  line-height: 1.1em;
  display: flex;
  flex-direction: column;
  text-align: left;
}
/* Mesmo padrão visual do monitoramento de Atuadores: grid fluido substituindo os
   degraus fixos de largura (25%) de main.css, e altura uniforme via flex column
   (footer sempre encostado embaixo, mesmo com quantidades de conteúdo diferentes
   entre cards vizinhos — ex.: RSSI só aparece quando o dado existe). Altura
   baseada no maior conteúdo possível (nome+modelo, sinal+bateria, e as duas
   badges de alerta juntas — "Não sincronizado" + "Bateria baixa", medido em
   ~190px) — evita cards desalinhados quando um vizinho tem só uma badge (ou
   nenhuma). */
.monitCard {
  display: flex;
  flex-direction: column;
  min-height: 192px;
}
.monitCard footer {
  position: static;
  margin-top: auto;
}
.container-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 10px;
}
.dir-space-card {
  width: auto;
  max-width: none;
  margin: 0;
}
.monit-model {
  font-size: 0.72em;
  font-weight: normal;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
  margin-top: 1px;
}
/* Mesma "hierarquia de alarmes" do monitoramento de Atuadores/Sensores —
   vermelho (error) pra não-sincronizado, laranja (warning) pra bateria baixa. */
.monitCard.has-alert {
  border-left: 4px solid transparent;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.18), 0 1px 3px rgba(0, 0, 0, 0.14);
}
.monitCard.has-alert--warning {
  border-left-color: #e07f00;
}
.monitCard.has-alert--error {
  border-left-color: #dc3545;
}
.monitCard .bat-low,
.monitCard .bat-low .material-design-icon {
  color: #e07f00;
}
.monitCard .warn-card {
  display: flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  padding: 1px 6px;
  margin: 2px 0;
  border-radius: 4px;
}
.monitCard .warn-card--battery {
  color: #e07f00;
  background-color: rgba(224, 127, 0, 0.12);
}
.monitCard .warn-card--sync {
  color: #dc3545;
  background-color: rgba(220, 53, 69, 0.12);
}
.monitCard footer #date.date-never-synced {
  /* .monitCard footer #date (main.css) trava max-width:57px, pensado pra data
     curta -- sem isso, "Aguardando comunicação" quebra em 2 linhas dentro de
     uma caixa larga fixa, e o fundo cobre a caixa inteira em vez do texto de
     verdade (linha 1 sobra espaço, linha 2 quase estoura). width:fit-content
     faz o fundo abraçar a linha mais larga de verdade, quebrando ou não. */
  width: fit-content;
  max-width: 100%;
  padding: 1px 6px;
  border-radius: 4px;
  color: #dc3545;
  font-weight: 600;
}
/* Em cards de falha (fundo vermelho/cinza escuro via bg-red-body/bg-black-body),
   as cores translúcidas acima ficam ilegíveis (texto vermelho sobre fundo vermelho).
   Usa texto branco sobre overlay escuro nesses casos. */
.monitCard.bg-red-body .warn-card--battery,
.monitCard.bg-black-body .warn-card--battery,
.monitCard.bg-red-body .warn-card--sync,
.monitCard.bg-black-body .warn-card--sync,
.monitCard.bg-red-body footer #date.date-never-synced,
.monitCard.bg-black-body footer #date.date-never-synced {
  color: #ffffff;
  background-color: rgba(0, 0, 0, 0.28);
}

.filter-model {
  max-height: 210px;
  overflow-y: auto;
  text-overflow: ellipsis;
  padding: 8px;
}
.monitCard .info .BAT {
  font-size: 1em;
  font-weight: 600;
  margin-bottom: 0.2em;
}
.BAT .material-design-icon {
  font-size: 1em;
  vertical-align: -0rem;
}
.percent-card {
  font-size: 1em;
  font-weight: 600;
}
.percent-card .material-design-icon {
  font-size: 0.85em;
  vertical-align: 1px;
}
@media screen and (max-width: 425px) {
  .monitCard {
    min-width: 89px !important;
  }
  .monitCard footer {
    width: 100%;
  }
  .monitCard footer #date {
    display: none;
  }
  .monitCard footer .status {
    width: 100%;
  }
}
@media screen and (max-width: 1170px) {
  .monitCard footer #date {
    font-weight: 600;
    font-size: 0.77em;
  }
}
</style>
